module.exports = __webpack_public_path__ + "static/media/banner3.bd551a62.webp";